export default __webpack_public_path__ + "static/media/TreesBackgroundDesktop.9afc518e.png";